<template>
    <div>
        <div
            class="tw-flex md:tw-items-center tw-justify-between"
            :class="{ 'max-md:tw-flex-col max-md:tw-gap-4': layout === 'row' }">
            <h2 class="tw-mb-0 tw-text-2xl tw-font-bold tw-text-dark tw-text-left">
                Últimos artigos sobre <span :class="`tw-text-${color}`">{{ tag.name }}</span>
            </h2>
            <v-btn
                v-if="layout === 'row'"
                append-icon="mdi-arrow-right"
                class="tw-px-0 tw-text-base max-md:tw-ms-auto"
                color="primary"
                elevation="0"
                flat
                :to="{ name: 'AllNews', query: { tag: tag.slug } }"
                variant="text">
                <span class="tw-font-medium">Ver todos</span>
            </v-btn>
        </div>

        <div
            v-if="layout === 'col'"
            class="tw-mt-10 tw-flex tw-flex-col tw-gap-8">
            <NewsHorizontalCard
                v-for="_news in news"
                :key="_news.id"
                :news="_news"
                :show-description="true" />
        </div>
        <div
            v-if="layout === 'row'"
            class="tw-mt-10">
            <NewsSlider :news="news" />
        </div>
        <v-btn
            v-if="layout === 'col'"
            append-icon="mdi-arrow-right"
            class="tw-mt-10 tw-px-0 tw-text-base"
            color="primary"
            elevation="0"
            flat
            :to="{ name: 'AllNews', query: { tag: tag.slug } }"
            variant="text">
            <span class="tw-font-medium">Ver todos os artigos de {{ tag.name }}</span>
        </v-btn>
    </div>
</template>

<script setup lang="ts">
    import NewsSlider from './NewsSlider.vue';

    const props = defineProps<{
        tag: any;
        layout: 'col' | 'row';
    }>();

    const news = computed(() => {
        return props.tag.news;
    });

    const color = computed(() => {
        return props.tag.color ?? 'primary';
    });
</script>

<style scoped></style>
